var BaseViews = require('./base');
require('./video-group/video-group.scss');
var VideoItems = require('./video-group/video-items');
var VideoGroup = BaseViews.LayoutView.extend({
    template: require('./video-group/video-group.html'),
    className: 'fmcy-video-group container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                videos: null,
                videoGroupTitle: 'Videos',
                appChannel: null
            }
        );
        this._videos = this.options.videos;
    },
    regions: {
        videosRegion: '.fmcy-videos-region'
    },
    serializeData: function () {
        return {
            videoGroupTitle: this.options.videoGroupTitle
        };
    },
    _renderVideos: function () {
      var self = this;
      this._videoItems = new VideoItems({
        collection: this._videos
      });
      this._videoItems.on('thumb:clicked', function (model, collection) {
        if (self.options.appChannel !== null) {
          self.options.appChannel.request(
              'load:enlarged:video',
              model,
              collection
          );
        }
      });
      this.videosRegion.show(this._videoItems);
    },
    onRender: function() {
        this._renderVideos();
    }
});

module.exports = VideoGroup;



/** WEBPACK FOOTER **
 ** ./assets/js/common/video-group.js
 **/